import React from 'react';
import { FaTwitter, FaDiscord, FaTelegram, FaMedium } from 'react-icons/fa';

const Footer = () => {
  return (
    <div className="footer">
      <div className="copyright">© sonus 2025</div>
      <div className="social-icons">
        <a href="https://twitter.com/SonusExchange" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaTwitter />
        </a>
        <a href="https://discord.gg/rHh9UN9wjG" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaDiscord />
        </a>
        <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaTelegram />
        </a>
        <a href="https://medium.com/@SonusExchange" target="_blank" rel="noopener noreferrer" className="social-icon">
          <FaMedium />
        </a>
      </div>
    </div>
  );
};

export default Footer;